<template>
  <div>
    <body>
  
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <h3 class="custom-64px text-white text-center">Select your Role</h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowParent()"
              :style="
                isShowParent
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Parent/Student</CButton
            >
            <!-- <CButton color="info" class="custom-btn-login-forgot ml-2" @click="ShowOnlineTutor()" :style="isShowOnline ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;' : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'">
              Online Tutor</CButton
            > -->

            <!-- <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowTc()"
              :style="
                isShowTc
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Edu. Center</CButton
            >

            <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Smart Classroom</CButton
            > -->
          </div>
        </div>

        <div class="text-center d-md-none">
          <h3 class="custom-32px text-white text-center">Select your Role</h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowParent()"
              :style="
                isShowParent
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Parent/Student</CButton
            >
            <!-- <br /><br />
            <CButton color="info" class="custom-btn-login-forgot" @click="ShowOnlineTutor()" :style="isShowOnline ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;' : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'">
              Online Tutor</CButton
            > -->
            <br /><br />
            <!-- <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowTc()"
              :style="
                isShowTc
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Edu. Center</CButton
            > -->
            <br /><br />
            <!-- <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Smart Classroom</CButton
            > -->
          </div>
        </div>
      </CContainer>

      <CRow v-if="ParentPrice === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Tuition Online Package</strong>
            </h1>
            <h1
              class="ml-5 mt-5 custom-32px text-center d-md-none"
              style="color: #000"
            >
              <strong>Tuition Online Package</strong>
            </h1>
            <label class="ml-2 mr-2 d-sm-down-none"
              >Choose the package that match with your budget and
              interest.</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >Choose the package that <br />match with your budget and
              interest.</label
            >

            <br />
            <div class="mt-5 mb-3">
              <CBadge
                color="default"
                class="default-badge"
                @click="GoToPrimarySchool()"
                :style="
                  isShowPrim
                    ? 'border: 2px solid #007CEF;color:#007CEF'
                    : 'border: 1px solid white;'
                "
                >Primary School</CBadge
              >

              <CBadge
                color="default"
                class="default-badge ml-3"
                @click="GoToSecondarySchool()"
                :style="
                  isShowSec
                    ? 'border: 2px solid #007CEF;color:#007CEF'
                    : 'border: 1px solid white;'
                "
                >Secondary School</CBadge
              >
            </div>

            <CCol sm="12" v-if="PrimarySchool === true">
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>One To One</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 30</strong><span class="small text-muted">/session </span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                      <div class="text-center">
                        <label class="text-center">Option</label>
                      </div>
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 20 for 40 mins session</label>
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package One to One for Primary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <span class="custom-type-package">
                      <label class="ml-2">LIMITED</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Group Of Two</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 16</strong><span class="small text-muted">/session </span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Of Two for Primary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Group Titan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 8</strong><span class="small text-muted">/session </span>
                    </h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-active-signin mb-3"
                      > <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Titan for Primary School" style="color:#007CEF">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <span class="custom-type-package">
                      <label class="ml-2">LIMITED</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Group Of 3</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 12</strong><span class="small text-muted"> /session</span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      ><a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Of 3 for Primary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="12" v-if="SecondarySchool === true">
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>One To One</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 35</strong><span class="small text-muted">/session </span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                      <div class="text-center">
                        <label class="text-center">Option</label>
                      </div>
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 24 for 40 mins session</label>
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package One To One for Secondary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <span class="custom-type-package">
                      <label class="ml-2">LIMITED</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Group Of Two</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 18</strong><span class="small text-muted">/session </span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Of Two for Secondary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Group Titan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 10</strong><span class="small text-muted"> /session</span>
                    </h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-active-signin mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Titan for Secondary School" style="color:#39f">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <span class="custom-type-package">
                      <label class="ml-2">LIMITED</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Group Of 3</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 15</strong><span class="small text-muted"> /session</span></h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 hour session</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud class video recording</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label
                        >Teacher to share video recording <br />(By
                        request)</label
                      >
                      <br />
                    </div>
                    <div class="text-center custom-bottom-center-package">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      > <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Group Of 3 for Secondary School" style="color:#fff">
                        Buy Package</a></CButton
                      >
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <label class="ml-3 mr-3"
              >*This package for parent/tuition centre/daycare who want to
              enquire Pickiddo teacher to teach class online. All prices
              persession basis.</label
            >
            <br /><br /><br />
          </div>
        </div>
      </CRow>

      <CRow v-if="OnlineTutorPrice === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Compulsory Tutor’s Platform</strong>
            </h1>
            <h1
              class="ml-5 mt-5 custom-32px text-center d-md-none"
              style="color: #000"
            >
              <strong>Compulsory Tutor’s Platform</strong>
            </h1>
            <label class="ml-2 mr-2 d-sm-down-none"
              >Choose the package that match with your budget and
              interest.</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >Choose the package that <br />match with your budget and
              interest.</label
            >

            <br />
            <br />

            <label
              >Billing Cycle : Monthly
              <CSwitch
                class="mx-1"
                color="primary"
                :checked.sync="checkAnnually"
                shape="pill"
                v-model="checked"
                @click="CheckedType()"
              />
              Annual
            </label>

            <br />
            <br />

            <CCol sm="12" v-if="checkAnnually === true">
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Free Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 0</strong></h4>
                    <label>free for 5 students</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add payment gateway </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage </label>
                      <br />
                      <div class="text-center">
                        <br />
                        <label class="text-center custom-16px-blue">
                          Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        /></label>
                      </div>

                      <br />
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Starter Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 99</strong></h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>2 Teachers</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base / chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage </label>
                      <br />
                    </div>
                    <br />
                    <div class="text-center">
                      <label class="text-center custom-16px-blue">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Pro Plan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 499</strong>
                    </h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>300 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base/chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Cloud video storage (2GB)</label>
                      <br />
                    </div>
                    <div class="text-center">
                      <br />
                      <label class="text-center custom-16px-blue text-white">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>

                    <br />
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Business Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 999</strong></h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base/ chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage</label>
                    </div>
                    <div class="text-center">
                      <br />
                      <label class="text-center custom-16px-blue">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>

                    <br />
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="12" v-else>
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Free Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 0</strong></h4>
                    <label>free for 5 students</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add payment gateway </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage </label>
                      <br />
                      <div class="text-center">
                        <br />
                        <label class="text-center custom-16px-blue">
                          Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        /></label>
                      </div>

                      <br />
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Starter Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 125</strong></h4>
                    <label>billed monthly</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>2 Teachers</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base / chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage </label>
                      <br />
                    </div>
                    <br />
                    <div class="text-center">
                      <label class="text-center custom-16px-blue">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Pro Plan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 499</strong>
                    </h4>
                    <label>per student</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>300 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Cloud video storage (2GB)</label>
                      <br />
                    </div>
                    <div class="text-center">
                      <br />
                      <label class="text-center custom-16px-blue text-white">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>

                    <br />
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Business Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 1249</strong></h4>
                    <label>billed monthly</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />

                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Include Zoom teacher’s license</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Cloud video storage</label>
                    </div>
                    <div class="text-center">
                      <br />
                      <label class="text-center custom-16px-blue">
                        Show More
                        <img src="../assets/img/icon/iconarrowbottom.svg"
                      /></label>
                    </div>

                    <br />
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <label class="ml-3 mr-3"
              >*This package for parent/tuition centre/daycare who want to
              enquire Pickiddo teacher to teach class online. All prices
              persession basis.</label
            >
            <br /><br /><br />
          </div>
        </div>
      </CRow>

      <CRow v-if="TcPrice === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Educational Center Package</strong>
            </h1>
            <h1
              class="ml-5 mt-5 custom-32px text-center d-md-none"
              style="color: #000"
            >
              <strong>Educational Center Package</strong>
            </h1>
            <label class="ml-2 mr-2 d-sm-down-none"
              >Designed for Tuition centre, Kindergarten, DayCare, Tadika, Sport
              centre and Trainning centre</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >Designed for Tuition centre, Kindergarten, DayCare, Tadika, Sport
              centre and Trainning centre.</label
            >

            <br />
            <br />

            <label
              >Billing Cycle : Monthly
              <CSwitch
                class="mx-1"
                color="primary"
                :checked.sync="checkAnnuallyTc"
                shape="pill"
                v-model="checkedTc"
              />
              Annual
            </label>

            <br />
            <br />

            <CCol sm="12" v-if="checkAnnuallyTc === true">
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Free Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 0</strong><span class="small text-muted"> /month</span></h4>
                    <label>free for 5 students</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add payment gateway </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Management Report </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report </label>
                      <br />
                      <div class="text-center">
                        <label class="text-center custom-16px-blue" @click="ShowMoreAnFree()">
                         <div v-if="showMoreAnn===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                      </div> </label><br />
                    
                        <div v-if="showLess===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessAnFree()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <label class="text-center">Option</label> <br />
                          <div class="text-left">
                            <img src="../assets/img/icon/uncheck.svg" />
                          <label>Add Student </label>
                          <br />
                          <img src="../assets/img/icon/uncheck.svg" />
                          <label>Add Teacher </label>
                        </div>
                      </div>
                      </div>
                      <br />
                      <div class="text-center">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(8)">
                        Buy Package</div></CButton
                      >
                      
                    </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Starter Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 399</strong><span class="small text-muted"> /month</span></h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teachers</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base / chat support</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>

                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Management Report </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report </label>

                      <div class="text-center">
                        <label class="text-center custom-16px-blue" @click="ShowMoreAnStarter()">
                         <div v-if="showMoreAnnStarter===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                      </div> </label><br />
                    
                        <div v-if="showLessStarter===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessAnStarter()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                           <label class="text-center">Option</label> <br />
                            <img src="../assets/img/icon/check.svg" />
                          <label>Add Student (10px min) for RM2 per student</label>
                          <br />
                            <img src="../assets/img/icon/check.svg" />
                          <label>Add Teacher (RM15/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                    <br />
                      <div class="text-center">
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(5)">
                        Buy Package</div></CButton
                      >
                      </div>
                       


                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package-edu" style="background: linear-gradient(286.01deg,#5bc4ff 7.93%,#0085ff 96.74%);color: #fff;">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Pro Plan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 999</strong><span class="small text-muted"> /month</span>
                    </h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>300 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Teachers</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base/chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Management Report</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report</label>
                      <br />
                      <div class="text-center">
                        <label class="text-center custom-16px-blue text-white" @click="ShowMoreAnPro()">
                         <div v-if="showMoreAnnPro===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                      </div> </label><br />
                    
                        <div v-if="showLessPro===true">
                          <label class="text-center custom-16px-blue text-white" @click="ShowLessAnPro()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                            <label class="text-center">Option</label><br />
                        <img src="../assets/img/icon/check.svg" />
                      <label>Add Student (10px min) for RM1 per student</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add Teacher (RM10/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                  
                 


                    <div class="text-center">
                      <br />
                      <CButton
                        color="info"
                        class="btn custom-btn-login-active-signin btn-info mb-3"
                      >
                      <div style="color:#39f" @click="BuyPackageAnnuallyFree(6)">
                        Buy Package</div></CButton
                      >
                      </div>
                      

                    <br />
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Business Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 1999</strong><span class="small text-muted"> /month</span></h4>
                    <label>billed annually</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>700 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Unlimited</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base/ chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Management Report</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Detail Management Report</label>
                      <br />
                      <div class="text-center">
                        <label class="text-center custom-16px-blue" @click="ShowMoreAnBusiness()">
                         <div v-if="showMoreAnnBusiness===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                      </div> </label><br />
                    
                        <div v-if="showLessBusiness===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessAnBusiness()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                            <label class="text-center">Option</label><br />
                        <img src="../assets/img/icon/check.svg" />
                      <label>Add Student (10px min) for RM2 per student</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add Teacher (RM15/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div class="text-center">
                      <br />
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(7)">
                        Buy Package</div></CButton
                      >
                      </div>
                       


                    <br />
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="12" v-else>
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Free Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 0</strong><span class="small text-muted"> /month</span></h4>
                    <label>free for 5 students</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>1 Teacher</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base support</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add payment gateway </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Management Report</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report</label>
                      <div class="text-center">
                        <br />
                        <label class="text-center custom-16px-blue" @click="ShowMoreMhFree()">
                         <div v-if="showMoreMhFree===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                          </div> 
                        </label>
                    
                        <div v-if="showLessMhFree===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessMhFree()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                           <label class="text-center">Option</label>
                        <br />
                        <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add Student</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Add Teacher</label>
                        </div>
                      </div>
                    </div>
                      <div class="text-center">
                        <br />
                        <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(1)">
                        Buy Package</div></CButton
                      >
                      </div>
                       


                      <br />
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Starter Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 625</strong><span class="small text-muted"> /month</span></h4>
                    <label>billed monthly</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>5 Teachers</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base support/ chat</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>

                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Tuition Center Management Report </label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report </label>
                      <div class="text-center">
                        <br />
                        <label class="text-center custom-16px-blue" @click="ShowMoreMhStarter()">
                         <div v-if="showMoreMhStarter===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                          </div> 
                        </label>
                    
                        <div v-if="showLessMhStarter===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessMhStarter()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                           <label class="text-center">Option</label>
                           <br />
                        <img src="../assets/img/icon/check.svg" />
                      <label>Add Student (10px min) for RM2 per student</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add Teacher (RM15/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                   
                    <div class="text-center">
                      <br />
                      <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(2)">
                        Buy Package</div></CButton
                      >
                      </div>
                       

                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package-edu" style="background: linear-gradient(286.01deg,#5bc4ff 7.93%,#0085ff 96.74%);color: #fff;">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Pro Plan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 1225</strong><span class="small text-muted"> /month</span>
                    </h4>
                    <label>billed monthly</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>300 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>30 Teachers</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base support/chat </label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />

                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Management Report</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Detail Management Report</label>
                      <br />
                      <div class="text-center">
                        <br />
                        <label class="text-center custom-16px-blue text-white" @click="ShowMoreMhPro()">
                         <div v-if="showMoreMhPro===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                          </div> 
                        </label>
                    
                        <div v-if="showLessMhPro===true">
                          <label class="text-center custom-16px-blue text-white" @click="ShowLessMhPro()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                            <label class="text-center">Option</label>
                              <br />
                        <img src="../assets/img/icon/check.svg" />
                      <label>Add Student (10px min) for RM1 per student</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add Teacher (RM10/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div class="text-center">
                      <br />
                      <CButton
                        color="info"
                        class="btn custom-btn-login-active-signin btn-info mb-3"
                      >
                      <div style="color:#39f" @click="BuyPackageAnnuallyFree(3)">
                        Buy Package</div></CButton
                      >
                      </div>
                     


                    <br />
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Business Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 2249</strong><span class="small text-muted"> /month</span></h4>
                    <label>billed monthly</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>700 students</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Unlimited</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Knowledge base/ chat support</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>No Pickiddo offer Ads</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add payment gateway (RM2/transaction)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Dashboard</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Tuition Center Management Report</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Detail Management Report</label>
                      <br />
                      <div class="text-center">
                        <label class="text-center custom-16px-blue" @click="ShowMoreMhBusiness()">
                         <div v-if="showMoreMhBusiness===true">Show More
                          <img src="../assets/img/icon/iconarrowbottom.svg"
                        />  
                          </div> 
                        </label>
                    
                        <div v-if="showLessMhBusiness===true">
                          <label class="text-center custom-16px-blue" @click="ShowLessMhBusiness()">
                          Show Less
                          <img src="../assets/img/icon/iconarrowbottom.svg" style="transform: rotate(180deg);"
                        /></label><br />
                          <div class="text-left">
                              <label class="text-center">Option</label>
                              <br />
                        <img src="../assets/img/icon/check.svg" />
                      <label>Add Student (10px min) for RM2 per student</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Add Teacher (RM15/teacher) </label>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div class="text-center">
                      <br />
                      <CButton
                        color="info"
                        class="btn custom-btn-login-forgot btn-info mb-3"
                      >
                      <div style="color:#fff" @click="BuyPackageAnnuallyFree(4)">
                        Buy Package</div></CButton
                      >
                      </div>
                      


                    <br />
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <label class="ml-3 mr-3"
              >*This package for parent/tuition centre/daycare who want to
              enquire Pickiddo teacher to teach class online. All prices
              persession basis.</label
            >
            <br /><br /><br />
          </div>
        </div>
      </CRow>

      <CRow v-if="ClassPrice === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Smart Classroom Package</strong>
            </h1>
            <h1
              class="ml-5 mt-5 custom-32px text-center d-md-none"
              style="color: #000"
            >
              <strong>Smart Classroom Package</strong>
            </h1>
            <label class="ml-2 mr-2 d-sm-down-none"
              >One time payment for setting up Smart Classroom (make classroom
              ready with online class on bigger screen)</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >One time payment for setting up Smart Classroom (make classroom
              ready with online class on bigger screen)</label
            >

            <br />
            <br />

            <CCol sm="12">
              <CRow class="p-2">
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Basic</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 250</strong></h4>
                    <br />

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Smart TV + Webcam</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>55 Inch Smart TV</label>
                      <br />
                      <img src="../assets/img/icon/uncheck.svg" />
                      <label>Smart TV Price</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Titan Tuition Package</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Zero Deposit </label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 250 Installation fees</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Free Zoom Software </label>
                      <br />  <br />
                      <div class="text-center">
                        <br />
                        <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Basic Plan" style="color:#fff">
                        Buy Package</a></CButton
                      >
                      </div>

                      <br />
                    </div>
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Standard Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 3,749</strong></h4>
                    <label>billed once</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV + Webcam</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>55 Inch Smart TV</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV Price</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Titan Tuition Package</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Zero Deposit </label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 250 Installation fees</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Free Zoom Software </label>
                      <br />
                    </div>
                    <div class="text-center">
                        <br />
                        <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Standard Plan" style="color:#fff">
                        Buy Package</a></CButton
                      >
                      </div>

                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-blue-package-edu" style="background: linear-gradient(286.01deg,#5bc4ff 7.93%,#0085ff 96.74%);color: #fff;">
                    <span class="custom-type-package-offer">
                      <label class="ml-2">SPECIAL OFFER</label>
                    </span>
                    <h3 class="custom-32px-blue mt-5 text-white">
                      <strong>Best Plan</strong>
                    </h3>
                    <h4 class="custom-24px text-white">
                      <strong>RM 1,949</strong>
                    </h4>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV + Webcam</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>55 Inch Smart TV</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV Price Inclusive (Rental)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Titan Tuition Package</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 2099 Deposit</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 250 Installation fees</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Free Zoom Software </label>

                      <br />
                    </div>
                    <div class="text-center">
                        <br />
                        <CButton
                        color="info"
                        class="custom-btn-login-active-signin btn-info mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Best Plan" style="color:##39f">
                        Buy Package</a></CButton
                      >
                      </div>


                    <br />
                  </CCard>
                </CCol>
                <CCol sm="3">
                  <CCard class="custom-card-package-edu">
                    <h3 class="custom-32px-blue mt-5">
                      <strong>Premium Plan</strong>
                    </h3>
                    <h4 class="custom-24px"><strong>RM 3,749</strong></h4>
                    <label>billed once</label>

                    <div class="text-left p-2">
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV + Webcam</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>65 Inch Smart TV</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Smart TV Price Inclusive (Rental)</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Titan Tuition Package</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Zero Deposit</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>RM 350 Installation fees</label>
                      <br />
                      <img src="../assets/img/icon/check.svg" />
                      <label>Free Zoom Software </label>
                      <br />
                    </div>
                    <div class="text-center">
                        <br />
                        <CButton
                        color="info"
                        class="custom-btn-login-forgot mb-3"
                      >
                      <a href="https://wa.me/600106597700?text=+Hi, I would like to buy package Premium Plan" style="color:#fff">
                        Buy Package</a></CButton
                      >
                      </div>


                    <br />
                  </CCard>
                </CCol>
              </CRow>
            </CCol>

            <label class="ml-3 mr-3"
              >*This package for parent/tuition centre/daycare who want to
              enquire Pickiddo teacher to teach class online. All prices
              persession basis.</label
            >
            <br /><br /><br />
          </div>
        </div>
      </CRow>

      <div>
        <CContainer class="text-center">
          <CCard class="custom-bg-orange-card mt-3">
            <CRow class="p-2">
              <div style="width: 70%" class="p-3">
                <h3
                  style="white-space: nowrap"
                  class="custom-32px text-left mt-3 d-sm-down-none"
                >
                  Interested to register as an Organisation?
                </h3>
                <h3 class="custom-16px text-left mt-3 d-md-none text-white">
                  Interested to register as an Organisation?
                </h3>
                <label class="text-white text-left mt-3"
                  >Are you an big organisation or interested to register for
                  many students. Please contact us below for further
                  details.</label
                >
                <br />
                <div class="text-left">
                  <CButton
                    color="info"
                    class="custom-btn-login-active-signin text-left mt-2"
                  >
                  <a href="https://wa.me/600106597700?text=+Hi, I interested to register as an Organisation">
                    Contact Us Now
                    </a></CButton
                  >
                </div>
              </div>
              <div style="width: 30%">
                <img
                  style=" max-width: 300px;right: 0;position: absolute;bottom: 0;
                  " src="../assets/img/icon/organization.svg" class="d-sm-down-none"
                />
              </div>
            </CRow>
          </CCard>
          <CCol sm="12" class="p-0">
            <CRow class="p-0">
              <CCol sm="6" class="p-0">
                <div class="text-left">
                  <CCard class="custom-bg-color-yellow mt-3 custom-height-card">
                    <CRow>
                      <div style="width: 100%">
                        <h3
                          style="text-align: left"
                          class="header-card mt-3 ml-4"
                        >
                          <strong>Let’s Register with Us</strong>
                        </h3>
                        <br />
                      </div>
                      <div style="width: 60%" class="float-left">
                        <label class="header-card-subtitle ml-4">
                          Sign Up with Pickiddo to enjoy full benefits of
                          educations</label
                        >
                        <br /><br /><br />
                        <CButton
                          color="info"
                          class="
                            custom-btn-login-active-signin
                            float-left
                            text-left
                            ml-4
                            mb-2
                          "
                        >
                        <a href="https://wa.me/600106597700?text=+Hi, I would like to register with Pickiddo">
                          Sign Up</a></CButton
                        >
                      </div>
                      <div style="width: 40%" class="float-right">
                        <br /><br />
                        <img
                          style="
                            max-width: 50%;
                            right: 0;
                            position: absolute;
                            bottom: 0;
                          "
                          src="../assets/img/icon/twostudent.svg"
                        />
                      </div>
                    </CRow>
                  </CCard>
                </div>
              </CCol>
              <CCol sm="6" class="p-0">
                <div class="text-left">
                  <CCard class="custom-bg-color-yellow mt-3 custom-height-card">
                    <CRow>
                      <div style="width: 100%">
                        <h3
                          style="text-align: left"
                          class="header-card mt-3 ml-4"
                        >
                          <strong>Earn More With Pickiddo</strong>
                        </h3>
                        <br />
                      </div>
                      <div style="width: 60%" class="float-left">
                        <label class="header-card-subtitle ml-4">
                          Let’s help younger generations by educating
                          them.</label
                        >
                        <br /><br /><br />
                        <CButton
                          color="info"
                          class="custom-btn-login-active-signin ml-4 mb-2"
                        >
                        <a href="https://app.pickiddo.com/v3/#/LoginPickiddo">
                          Become a Tutor</a></CButton
                        >
                        <br />
                      </div>
                      <div style="width: 40%" class="float-right">
                        <br /><br />
                        <img
                          style="
                            max-width: 100%;
                            right: 0;
                            position: absolute;
                            bottom: 0;
                          "
                          src="../assets/img/icon/teacherchat.png"
                        />
                      </div>
                    </CRow>
                  </CCard>
                </div>
              </CCol>
            </CRow>
          </CCol>
          <br /><br /><br /><br />
        </CContainer>
      </div>
    </div>

    <Footerlayout></Footerlayout>

    <div v-if="registerOrganization === true">
      <div class="custom-fixed-card p-3">
        <br /><br />
        <h4 class="mt-5 custom-24px text-white">
          <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/> <strong class="ml-2">Register as Organization</strong>
        </h4>
        <br />
        <label class="text-white">Name</label>
        <br />
        <input type="text" class="custom-input-user" placeholder="eg. Danial Haikal"/>

        <br /><br />
        <CRow>
          <CCol sm="6">
            <label class="text-white">Enter Email</label>
            <br />
            <input type="text" class="custom-input-user" placeholder="eg. AliffShukri@gmail.com"/>
          </CCol>
          <CCol sm="6">
            <label class="text-white">Phone Number</label>
            <br />
            <input type="text" class="custom-input-user" placeholder="eg. 0123456765"/>
          </CCol>
        </CRow>
        <br />
        <label class="text-white">Enquiry/Note</label>
        <br />
        <input type="text" class="custom-input-user" placeholder="eg. I want to register as an Organisation"/>

        <div class="custom-bottom-center text-center">
          <CButton color="info" class="custom-btn-login-active-signin" block>
              Submit Application</CButton
            >
        </div>
      </div>
    </div>
  </div>
</body>
</div>
</template>
  
  
  
  
  <script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

import VueMeta from "vue-meta";
Vue.use(VueMeta);

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute("style", "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)");
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute("style", "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)");
      }
    },
  },
});
export default {
  metaInfo: {
    title: 'Package - "Discover our package subscription options designed to meet your specific needs ',
    meta: [
      { property: 'og:title', content: 'Package - Discover our package subscription options designed to meet your specific needs' }
    ],
    link: [
        { rel: 'canonical', href: 'https://www.pickiddo.com/Package' }
      ]
  },
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout
  },
  data() {
    return {
      slides: 5,

      ParentPrice: true,
      isShowParent: true,

      PrimarySchool: true,
      SecondarySchool: false,
      isShowPrim: true,
      isShowSec: false,

      OnlineTutorPrice: false,
      isShowOnline: false,

      checked: true,
      checkAnnually: true,
      checkedMonthly: false,

      TcPrice: false,
      isShowTc: false,

      checkAnnuallyTc: true,
      checkedTc: true,

      ClassPrice: false,
      isShowClass: false,

      registerOrganization: false,

     


      showLess: false,
      showMoreAnn: true,

      showLessStarter: false,
      showMoreAnnStarter: true,

      showLessPro: false,
      showMoreAnnPro: true,

      showLessBusiness: false,
      showMoreAnnBusiness: true,

      showLessMhFree: false,
      showMoreMhFree: true,

      showLessMhStarter: false,
      showMoreMhStarter: true,

      showLessMhPro: false,
      showMoreMhPro: true,

      showLessMhBusiness: false,
      showMoreMhBusiness: true,
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    
  },

  methods: {
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    ShowParent() {
      this.ParentPrice = true;
      this.isShowParent = true;
      this.isShowOnline = false;
      this.isShowTc = false;
      this.isShowClass = false;

      this.ClassPrice = false;
      this.TcPrice = false;

    },
    GoToPrimarySchool() {
      this.PrimarySchool = true;
      this.SecondarySchool = false;
      this.isShowPrim = true;
      this.isShowSec = false;
    },
    GoToSecondarySchool() {
      this.PrimarySchool = false;
      this.SecondarySchool = true;
      this.isShowSec = true;
      this.isShowPrim = false;
    },
    ShowOnlineTutor() {
      this.OnlineTutorPrice = true;
      this.ParentPrice = false;
      this.isShowParent = false;
      this.isShowOnline = true;
      this.isShowTc = false;
      this.isShowClass = false;
    },
    CheckedType() {
      if (this.checked) {
        this.checkAnnually = true;
        this.checkedMonthly = false;
      } else {
        this.checkAnnually = false;
        this.checkedMonthly = true;
      }
    },
    ShowTc() {
      this.TcPrice = true;

      this.isShowTc = true;
      this.isShowOnline = false;
      this.isShowParent = false;
      this.isShowClass = false;

      this.OnlineTutorPrice = false;
      this.ParentPrice = false;
      this.ClassPrice = false;
    },

    ShowClass() {
      this.ClassPrice = true;
      this.isShowClass = true;

      this.isShowOnline = false;
      this.isShowParent = false;
      this.isShowTc = false;

      this.OnlineTutorPrice = false;
      this.TcPrice = false;
      this.ParentPrice = false;
    },
    GoBack()
    {
      this.registerOrganization = false;
    },
    OpenOrganization()
    {
      this.registerOrganization = true;
    },
    ShowMoreAnFree()
    {
      this.showLess = true;
      this.showMoreAnn = false;
    },
    ShowLessAnFree()
    {
      this.showLess = false;
      this.showMoreAnn = true;
    },
    ShowMoreAnStarter()
    {
      this.showLessStarter = true;
      this.showMoreAnnStarter = false;
    },
    ShowLessAnStarter()
    {
      this.showLessStarter = false;
      this.showMoreAnnStarter = true;
    },
    ShowMoreAnPro()
    {
      this.showLessPro = true;
      this.showMoreAnnPro = false;
    },
    ShowLessAnPro()
    {
      this.showLessPro = false;
      this.showMoreAnnPro = true;
    },
    ShowMoreAnBusiness()
    {
      this.showLessBusiness = true;
      this.showMoreAnnBusiness = false;
    },
    ShowLessAnBusiness()
    {
      this.showLessBusiness = false;
      this.showMoreAnnBusiness = true;
    },
    ShowMoreMhFree()
    {
      this.showLessMhFree = true;
      this.showMoreMhFree = false;
    },
    ShowLessMhFree()
    {
      this.showLessMhFree = false;
      this.showMoreMhFree = true;
    },
    ShowMoreMhStarter()
    {
      this.showLessMhStarter = true;
      this.showMoreMhStarter = false;
    },
    ShowLessMhStarter()
    {
      this.showLessMhStarter = false;
      this.showMoreMhStarter = true;
    },
    ShowMoreMhPro()
    {
      this.showLessMhPro = true;
      this.showMoreMhPro = false;
    },
    ShowLessMhPro()
    {
      this.showLessMhPro = false;
      this.showMoreMhPro = true;
    },
    ShowMoreMhBusiness()
    {
      this.showLessMhBusiness = true;
      this.showMoreMhBusiness = false;
    },
    ShowLessMhBusiness()
    {
      this.showLessMhBusiness = false;
      this.showMoreMhBusiness = true;
    },
    BuyPackageAnnuallyFree(PackageId)
    {
      this.$router.push("EducationCenter?PackageId=" + PackageId)
    }
  },
};
</script>
      <style scoped>
  
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
      
  .c-header {
    /* background: rgb(23, 77, 124);
    background: linear-gradient(92deg, #174d7c, #1b7682);
    border-bottom: 0.01px solid #1a6783;
    border-bottom: 1px solid #636f83; */
  
    background: transparent;
    border-bottom: 0;
    border-bottom: 0;
    /* color: #fff; */
  }
  .c-app{
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    font-family: 'Montserrat', sans-serif;
  }
  body {
    font-family: "Montserrat", sans-serif;
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      margin-bottom: 0.5rem;
      font-weight: 500;
      line-height: 1.2;
      font-family: "Montserrat", sans-serif;
  }
  label
  {
    font-family: "Montserrat", sans-serif;
  }
  
  body nav.onScroll {
    box-shadow: 0 0 10px #aaa;
    background-color: rgb(255, 255, 255);
    font-family: 'Montserrat';
  font-style: normal;
  }
  body nav.onScroll ul li {
    color: #10b761;
  }
  body nav ul {
    margin-left: 3em;
    width: 25%;
    display: flex;
    justify-content: space-between;
  }
  body nav ul li {
    cursor: pointer;
    font-weight: 600;
    list-style-type: none;
    color: white;
  }
  body {
      top: 0 !important;
      font-family: 'Montserrat', sans-serif;
  }

  
input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
   -webkit-text-fill-color: white !important;

}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
      </style>